import { Injectable } from '@angular/core';
import { configuration } from 'src/app/app.config';
import { Logger } from 'src/app/shared/shared-base/amg-ui/logging/logging/logger';
// tslint:disable: no-console

@Injectable()
export class ConsoleLogger implements Logger {
  private _enabled: boolean = configuration.logging.console.enabled;
  public error(error: Error, message?: string) {
    if (this._enabled) {
      console.error(error);
    }
  }
  public info(message: string) {
    if (this._enabled) {
      console.info(message);
    }
  }
  public warning(message: string) {
    if (this._enabled) {
      console.warn(message);
    }
  }
}
